<!-- 下拉选择器组件分装 -->
<template>
  <div style="width:100%;">
    <div id="divMap" style="width:100%;height: 550px;"></div>
    <div style="text-align: right;margin-top: 5px;">
      <el-button type="primary" @click="handleCallBack()" size="small">确 定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "open-map",
  props: ["longitude", "latitude", "isShow"],
  data() {
    return {
      currentMap: Object,
      currentMarker: Object,
      lnglat:{longitude:0}
    }
  },
  watch: {
    isShow: {
      handler(newValue) {
        if (newValue) {
          this.$nextTick(() => {
            this.addMarker()
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleCallBack() {
      if(this.lnglat.longitude>0){
        this.$emit("callBack", this.lnglat);
      }
      else{
        this.$emit("callBack", {longitude:this.longitude,latitude:this.latitude});
      }

    },
    addMarker() {
      this.currentMap = new window.AMap.Map("divMap", {
        viewMode: '2D', //默认使用 2D 模式
        zoom: 15, //地图级别
        center: [this.longitude, this.latitude], //地图中心点
      });
      let that=this
      this.currentMap.on("click", function (ev) {
        //触发事件的对象
        var target = ev.target;
        //触发事件的地理坐标，AMap.LngLat 类型
        var lnglat = ev.lnglat;
        //触发事件的像素坐标，AMap.Pixel 类型
        var pixel = ev.pixel;
        //触发事件类型
        var type = ev.type;
        that.addMarkerAction(lnglat.lng, lnglat.lat,true); //Marker 经纬度
        that.lnglat={longitude:lnglat.lng,latitude:lnglat.lat}
      });

      this.addMarkerAction(this.longitude,this.latitude,false)

    },
    addMarkerAction(longitude,latitude,flag){
      if(flag){
        this.currentMap.remove(this.currentMarker)
      }
      const position = new window.AMap.LngLat(longitude, latitude); //Marker 经纬度
      this.currentMarker = new window.AMap.Marker({
        position: position,
        offset: new window.AMap.Pixel(-13, -30), //以 icon 的 [center bottom] 为原点
      });
      this.currentMap.add(this.currentMarker)
    }
  },
  mounted() {

  }
}
</script>

<style scoped lang="scss"></style>